import { render, staticRenderFns } from "./FISS_Department.vue?vue&type=template&id=1f6a2304&scoped=true&"
import script from "./FISS_Department.vue?vue&type=script&lang=js&"
export * from "./FISS_Department.vue?vue&type=script&lang=js&"
import style0 from "./FISS_Department.vue?vue&type=style&index=0&id=1f6a2304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6a2304",
  null
  
)

export default component.exports